import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import TransferScheduleForm from '~/components/transferScheduleForm/transferScheduleForm';
import { transferScheduleValidationSchema } from '../../validation/transferSchedule';

export const createTransferScheduleMutation = gql`
  mutation createTransferSchedule(
    $breweryId: Int!
    $name: String!
    $description: String
    $isConsolidated: Boolean
    $transfers: [TransferForScheduleCreate]!
  ) {
    createTransferSchedule(
      breweryId: $breweryId
      name: $name
      description: $description
      transfers: $transfers
      isConsolidated: $isConsolidated
    ) {
      id
      name
      breweryId
      description
      isConsolidated
      transfers {
        id
      }
    }
  }
`;

export const mapTransferValuesForSave = (transfer, idx) => ({
  stepNumber: idx + 1,
  days: transfer.days,
  name: transfer.name,
  notes: transfer.notes,
  type: transfer.type,
  isConsolidated: transfer.type === 'TANK' ? transfer.tankType === 'UNI_TANK' : false,
  requiresDutyPaid: transfer.requiresDutyPaid,
  tankId: transfer.tankId,
  locationId: transfer.locationId,
  tankType: transfer.type === 'TANK' ? transfer.tankType : null,
  vesselDescription: transfer.type === 'VESSEL' ? transfer.vesselDescription : null,
  nextTransferScheduleId:
    (transfer.type === 'TANK' ** transfer.tankType) === 'UNI_TANK' ? transfer.nextTransferScheduleId : null
  // Todo - still to do locations
});

export const TransferScheduleCreateForm = ({ brewery, history, client }) => (
  <div className="content">
    <Mutation mutation={createTransferScheduleMutation}>
      {createTransferSchedule => (
        <Formik
          initialValues={{
            isConsolidated: false,
            transfers: [
              {
                name: '',
                type: 'TANK',
                tankType: 'BRITE_TANK',
                isConsolidated: false,
                requiresDutyPaid: false
              }
            ]
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={transferScheduleValidationSchema}
          onSubmit={async (values, { setErrors, setSubmitting }) => {
            const valuesToSave = Object.assign({}, values, {
              transfers: values.transfers.map(mapTransferValuesForSave)
            });

            try {
              const newTransferSchedule = await createTransferSchedule({
                variables: {
                  ...valuesToSave,
                  breweryId: brewery.id
                },
                refetchQueries: ['transferSchedules']
              });
              history.push(`/settings/transfers?new=${newTransferSchedule.data.createTransferSchedule.name}`);
            } catch (err) {
              setErrors({
                unknown: 'An unknown error occured'
              });
              setSubmitting(false);
            }
          }}
          render={TransferScheduleForm}
        />
      )}
    </Mutation>
  </div>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(TransferScheduleCreateForm)));



// WEBPACK FOOTER //
// ./src/containers/transferScheduleCreate/transferScheduleCreate.jsx